import { render, staticRenderFns } from "./CoursesBySchool.vue?vue&type=template&id=2e6f01a9&scoped=true&"
import script from "./CoursesBySchool.vue?vue&type=script&lang=js&"
export * from "./CoursesBySchool.vue?vue&type=script&lang=js&"
import style0 from "./CoursesBySchool.vue?vue&type=style&index=0&id=2e6f01a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6f01a9",
  null
  
)

export default component.exports